<template>
  <v-app>
    <Def>
      <v-container fluid style="margin-top:100px; width:90%;">
        <v-row>
          <v-col cols="6" class="pa-0 pr-3">
            <Space>
              <v-col cols="12">
                <v-row justify="center">
                  <v-avatar color="orange" size="84">
                    <v-img :src="ava"></v-img>
                  </v-avatar>
                </v-row>
                <v-row
                  class="font-weight-bold"
                  justify="center"
                  style="font-size:0.9vw"
                >{{$ls.get("Org")}}</v-row>

                <v-row justify="center" style="font-size:0.85vw">
                  <v-col cols="3" class="pb-0 pt-0">
                    <Ndiv :Data="1" :Title="'Студентов на обучении'"></Ndiv>
                  </v-col>
                  <v-col cols="3" class="pb-0 pt-0">
                    <Ndiv :Data="1 + 1" :Title="'Вакансий'"></Ndiv>
                  </v-col>
                  <v-col cols="3" class="pb-0 pt-0">
                    <Ndiv :Data="1 + 2" :Title="'Стажеров'"></Ndiv>
                  </v-col>
                </v-row>
              </v-col>
            </Space>
          </v-col>
          <v-col cols="6" class="pa-0 pl-3">
            <Space>
              <v-row class="ma-0 pr-3">
                <v-col class="pa-0">
                  <v-row>
                    <v-col cols="12" style="font-size:0.8vw">
                      <div>{{$ls.get("info")}}</div>
                    </v-col>
                  </v-row>
                  <v-row class="pl-3 font-weight-bold">
                    <a
                      :href="'https://www.' + $ls.get('website') + '/'"
                      class="link"
                    >{{$ls.get("website")}}</a>
                  </v-row>
                  <v-row class="ma-0 mt-15">
                    <v-col cols="6">
                      <v-spacer></v-spacer>
                    </v-col>
                    <v-col cols="6" class="pa-0">
                      <v-row justify="end" align="end">Рейтинг: 10</v-row>
                      <v-row justify="end" align="end">
                        <v-col cols="6" class="pr-0">
                          <v-btn color="#5B98F1" width="100%" rounded depressed>
                            <v-icon size="26">question_answer</v-icon>
                            <p
                              class="black--text mt-3 text-capitalize"
                              style="font-size:0.8vw;"
                            >Написать</p>
                          </v-btn>
                        </v-col>
                        <v-col cols="6" class="pr-0">
                          <v-btn color="#FFCF36" width="100%" rounded outlined>
                            <v-icon size="26">thumbs_up_down</v-icon>
                            <p
                              class="black--text mt-3 text-capitalize"
                              style="font-size:0.8vw;"
                            >Оставить отзыв</p>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </Space>
          </v-col>
        </v-row>
        <v-row class="mt-5">
          <v-card width="100%" flat>
            <v-tabs v-model="tab" class="pl-16">
              <v-tab v-for="item in items" :key="item.tab">{{ item.tab }}</v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
              <v-tab-item v-for="(item,i) in items" :key="item.tab">
                <Space>
                  <v-row v-for="itemy in item.content " :key="itemy.cont">
                    <Gen :Kval="itemy.Kval" :Kolvo="itemy.Kolvo" v-if="i==0" />

                    <Staj :title="itemy.title" :Dat="itemy.Dat" :Summa="itemy.Summa" v-if="i==1" />
                    <Proj
                      :title="itemy.title"
                      :Kolvo="itemy.Kolvo"
                      :State="itemy.State"
                      :Rab="itemy.Rab"
                      v-if="i==2"
                    />
                    <Otz v-if="i==5" :Fio="itemy.Fio" :Rat="itemy.Rat" :otz="itemy.otz" />
                  </v-row>
                  <Vak v-if="i==3" />
                  <KonD v-if="i==4" />
                </Space>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-row>
      </v-container>
    </Def>
  </v-app>
</template>

<script>
import KonD from "../KontDan";
import Otz from "../Otziv";
import Gen from "./general";
import Proj from "../project";
import Staj from "./staj";
import Vak from "./Vak";
export default {
  components: {
    KonD,
    Otz,
    Gen,
    Vak,
    Staj,
    Proj,
  },
  data() {
    return {
      tab: 0,
      items: [
        {
          tab: "Главная",
          content: [{ Kval: ".Net разработчики", Kolvo: 500 }],
        },
        {
          tab: "Стажировки",
        },
        {
          tab: "Проекты",
          content: [
            {
              title: "разработка лендинга",
              Kolvo: "4",
              State: "Продан",
              Rab: "",
            },
            {
              title: "Новая система администрирования",
              Kolvo: "14",
              State: "В разработке",
              Rab: ["инженер проектировщик", "frontend разработчик"],
            },
          ],
        },
        {
          tab: "Открытые вакансии",
        },
        {
          tab: "Контактная информация",
        },
        {
          tab: "Отзывы",
          content: [
            {
              Fio: "Фаттахов Айнур Джамилевич",
              Rat: 4,
              otz: "Хорошая организация, остался бы",
            },
            {
              Fio: "Горбунов Даниил Васильевич",
              Rat: 5,
              otz: "Платят много, обращаются хорошо",
            },
          ],
        },
      ],
    };
  },
  computed: {
    ava() {
      if (this.$ls.get("avatar") != undefined) {
        return this.$ls.get("avatar");
      } else {
        return "";
      }
    },
  },
};
</script>

<style>
a.link {
  text-decoration: none;
  color: #000;
}
a.link:hover {
  color: blue;
  text-decoration: underline;
}
</style>